import * as EmailValidator from 'email-validator'

export default email => EmailValidator.validate(email)
